import useReveal from "../../components/useReveal";

export default function LegalShell({ title, date, children }) {
  useReveal();
  return (
    <div className="legal-wrap">
      <div className="legal-header">
        <div className="container-narrow">
          <div style={{fontSize:12,fontWeight:600,letterSpacing:".06em",textTransform:"uppercase",color:"var(--text-tertiary)",marginBottom:10}}>Legal</div>
          <h1 style={{fontSize:"clamp(34px,5vw,52px)",fontWeight:700,color:"var(--text-primary)",letterSpacing:"-.025em",lineHeight:1.08,marginBottom:10}}>{title}</h1>
          <p style={{fontSize:13,color:"var(--text-tertiary)"}}>Last updated: {date}</p>
        </div>
      </div>
      <div className="container-narrow" style={{padding:"56px 2rem"}}>
        <div className="legal-content">{children}</div>
      </div>
    </div>
  );
}
